import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../images/location_new/revolutionize.png";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Why Choose TekRevol For Mobile App Development in NYC?</h2>
            <p>
              Discover TekRevol's seamless fusion of innovation and local
              expertise, influencing unparalleled mobile app solutions in New
              York City. Our agile approach guarantees compliance with trends
              and growing requirements, providing swift iterations. TekRevol
              offers custom software development, along with feature-rich app
              development to the clients worldwide. Post-deployment, our
              continuous maintenance guarantees flawless app performance. Opt
              for the services of TekRevol in NYC for a unique, customised app
              development experience that distinguishes your project from the
              competition. We rank affordability and simplicity over unrealistic
              features without compromising quality, making app development
              obtainable to small or big business ventures.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="app developer nyc"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
